import { LAUNCHED_COUNTRY } from "../../config/appConfigConstants";

export const GLOBAL_CONTACT_US_URL = "https://hiring.amazon.com/global-contact-us";

export const sdaAccessorCountries = [LAUNCHED_COUNTRY.US, LAUNCHED_COUNTRY.MX];
